import { Button, Input, P, Strong } from '@driftt/tide-core'
import {
  ModalBody,
  ModalFooter,
  ModalTitle,
  useCloseModal,
} from '@driftt/tide-modal'
import { Table } from '@driftt/tide-table'
import cx from 'classnames'
import React, { useState } from 'react'

import BotVariantIndicator from 'components/BotVariantIndicator'
import TrendIndicator, { TrendDirection } from 'components/TrendIndicator'
import { EMPTY_SET } from 'hooks/useExperimentMetrics.hook'
import { TypeFormats } from 'utils/format'
import { isEmptyOrNil } from 'utils/index'

import './styles.css'

const Experiment = {
  A: 'a',
  B: 'b',
}

const columns = [
  {},
  {
    label: 'Flow',
    className:
      'end-experiment-results-table-header end-experiment-results-table-header--indicator',
    width: 42,
  },
  { label: 'Sends' },
  { label: 'Conversati…' },
  { label: 'Emails cap…' },
  { label: 'Meetings' },
  {},
].map((col) => ({
  className: 'end-experiment-results-table-header',
  ...col,
}))

const WinnerSelection = ({
  experimentResults,
  timeSinceLastPublish,
  onEndExperiment,
}) => {
  const results = !isEmptyOrNil(experimentResults)
    ? experimentResults
    : [EMPTY_SET, EMPTY_SET]
  const handleCloseModal = useCloseModal()
  const [selectedExperiment, setSelectedExperiment] = useState(Experiment.A)
  const [metricsFlowA] = results

  const handleEndTestClick = () => {
    onEndExperiment({ useVariant: selectedExperiment === Experiment.B })
    handleCloseModal()
  }

  const getComparativeCells = (metrics, isFlowB) =>
    metrics.slice(2).map((n, i) => {
      const pctChange = (n / metrics[i + 1]) * 100
      const pctChangeA = (metricsFlowA[i + 2] / metricsFlowA[i + 1]) * 100
      const pctChangeDelta = pctChange - pctChangeA

      const trendDirection =
        pctChangeDelta > 0 ? TrendDirection.POSITIVE : TrendDirection.NEGATIVE

      const showTrendIndicator = isFlowB && !!pctChangeDelta

      return {
        className: 'end-experiment-results-table-cell',
        content: (
          <>
            <span className="end-experiment-results-table-cell-number">
              {TypeFormats.RAW_HUMANIZED(n)}
            </span>
            <span className="end-experiment-results-table-cell-percent">
              {' '}
              / {TypeFormats.PERCENT_WITH_DECIMAL(pctChange)}
              {showTrendIndicator && (
                <TrendIndicator
                  className="end-experiment-results-table-trend-indicator"
                  direction={trendDirection}
                />
              )}
            </span>
          </>
        ),
      }
    })

  const getRows = results.map((metrics, index) => {
    const experiment = !!index ? Experiment.B : Experiment.A
    const isSelected = experiment === selectedExperiment
    const isFlowB = !!index

    return {
      rowClickEventData: experiment,
      className: cx('end-experiment-results-table-row', {
        'end-experiment-results-table-row--selected': isSelected,
      }),
      data: [
        {
          className: 'end-experiment-results-table-cell--radio',
          content: <Input type="radio" checked={isSelected} readOnly />,
        },
        {
          className: 'end-experiment-results-table-cell--indicator',
          content: <BotVariantIndicator flowB={isFlowB} />,
        },
        {
          content: TypeFormats.RAW_HUMANIZED(metrics[1]),
        },
        ...getComparativeCells(metrics, isFlowB),
        {},
      ].map(({ className, ...cell }) => ({
        ...cell,
        className: cx(className, 'end-experiment-results-table-cell'),
      })),
    }
  })

  return (
    <>
      <ModalTitle>It's time to choose a winner!</ModalTitle>
      <ModalBody>
        <P>
          This A/B test has been running for{' '}
          <Strong>{timeSinceLastPublish}</Strong>. Which bot flow should be used
          moving forward?
        </P>

        <Table
          onRowClick={setSelectedExperiment}
          className="end-experiment-results-table"
          columns={columns}
          data={getRows}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleEndTestClick}>End test</Button>
        <Button
          onClick={handleCloseModal}
          style={{ marginLeft: 8 }}
          type="tertiary"
        >
          Cancel
        </Button>
      </ModalFooter>
    </>
  )
}

export default WinnerSelection
